<sc-flex vertical fitHeight stretchContent>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.station-selection-dialog.title"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-flex-fitting-content vertical>
    <sc-flex vertical fitHeight stretchContent>
      <div class="reasonSelector">
        <app-dictionary-key-select (selectionChanged)="optionsChanged($event)"
          [required]="configurationService.isPropertyTrue('ui-component.station-assignment-client.forward-transport-dialog.forwarding-cause.required', true)"
          label="{{'forwarding cause' | translate: ['tmc-yard.ui.control.station-selection.forward-transport-dialog.cause-selection.title', translationService.language, translationService.revision]}}"
          [rootKey]="'tmc-yard.service.lookup.forwarding-cause.options'" [required]="false">
        </app-dictionary-key-select>
      </div>
      <sc-flex-fitting-content vertical>
        <app-structure-selection [request]="request" (selectionChanged)="handleSelectionChanged($event)"></app-structure-selection>
      </sc-flex-fitting-content>
    </sc-flex>
  </sc-flex-fitting-content>

  <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <button mat-stroked-button (click)="cancelDialog()">
        <sc-dictionary-label dictionaryKey="shared.selection-dialog.action.cancel"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="confirmDialog()" [disabled]="!selectionValid">
        <sc-dictionary-label dictionaryKey="shared.selection-dialog.action.confirm"></sc-dictionary-label>
      </button>
  </sc-actionbar>
</sc-flex>
